import React from 'react'

const AxiosIndicatorRunTimeLoader = (props) => {
    const {inline,overlay, bomLoaderClass} = props;
    return (
        <>
            <div 
                className={`loader-wrapper ${(inline !== undefined && inline === true) ? 'loader-wrapper-inline' : ''} ${(overlay !==undefined && overlay === true) ? ' loader-wrapper-fixed':''} ${(bomLoaderClass !==undefined && bomLoaderClass === true) ? ' p-0':''}`}>
                <div className={bomLoaderClass !==undefined && bomLoaderClass === true ? "loading-icon clearfix m-0" : "loading-icon clearfix "}>
                    <div className="ball1"/>
                    <div className="ball2"/>
                    <div className="ball3"/>
                </div>
            </div>
        </> 
    )
}

export default AxiosIndicatorRunTimeLoader